import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, pure } from 'recompose'

import { dismissToasterMessage } from 'data/ui/actions'
import { getActiveToasterMessages } from 'data/ui/selectors'
import ToasterItem from './Item'

const enhance = compose(
  pure,
  connect(
    state => ({
      activeToasterMessages: getActiveToasterMessages(state),
    }),
    { dismissToasterMessage }
  )
)

const MAX_TOASTER_MESSAGES = 5

export class ToasterContainer extends PureComponent {
  static propTypes = {
    activeToasterMessages: PropTypes.object.isRequired,
    dismissToasterMessage: PropTypes.func.isRequired,
  }

  render() {
    return this.props.activeToasterMessages.size > 0 ? (
      <div
        className="flexbox flexbox-align-end flexbox-column position-fixed slite-design-system"
        style={{ top: 24, right: 24, zIndex: 9999 }} // Hover modals and everything, zIndex limbo
      >
        {this.props.activeToasterMessages
          .toList()
          .slice(-1 * MAX_TOASTER_MESSAGES)
          .toJS()
          .reverse()
          .map(this.renderToast)}
      </div>
    ) : (
      false
    )
  }

  renderToast = toasterMessage => (
    <ToasterItem
      key={toasterMessage.id}
      title={toasterMessage.title}
      detail={toasterMessage.detail}
      type={toasterMessage.type}
      renderAction={toasterMessage.renderAction}
      onClose={() =>
        this.props.dismissToasterMessage({ id: toasterMessage.id })
      }
    />
  )
}

export default enhance(ToasterContainer)
